import { upperFirst } from "lodash-es";

import { UserPassportType } from "Bands/types";
import { copy } from "shared/assets";
import { DateChangeProps, IFieldType, IFormFields } from "shared/types";

const { userPassport, errors } = copy;

export const getFormFields = ({
  handleIssueDateChange,
  handleExpiryDateChange,
  isIssueBeforeExpiry,
  isExpiryInFuture,
}: {
  handleIssueDateChange: (date: DateChangeProps) => void;
  handleExpiryDateChange: (date: DateChangeProps) => void;
  isIssueBeforeExpiry: boolean;
  isExpiryInFuture: boolean;
}): IFormFields => {
  return [
    {
      name: "title",
      label: userPassport.fields.title,
      type: IFieldType.text,
    },
    {
      name: "documentType",
      label: userPassport.fields.documentType.title,
      placeholder: userPassport.fields.documentType.placeholder,
      type: IFieldType.select,
      options: (Object.keys(UserPassportType) as Array<keyof typeof UserPassportType>).map(key => ({
        value: UserPassportType[key],
        label: upperFirst(UserPassportType[key].replaceAll("_", " "))
          .replaceAll("id", "ID")
          .replaceAll("card", "Card"),
      })),
      validation: {
        required: errors.required,
      },
    },
    {
      name: "issuingCountry",
      label: userPassport.fields.issuingCountry,
      type: IFieldType.country,
      validation: {
        required: errors.required,
      },
    },
    {
      name: "issuingAuthority",
      label: userPassport.fields.issuingAuthority,
      type: IFieldType.text,
    },
    {
      name: "passportNumber",
      label: userPassport.fields.passportNumber,
      type: IFieldType.text,
      validation: {
        required: errors.required,
      },
      style: {
        gridColumn: "span 2",
      },
    },
    {
      name: "issueDate",
      label: userPassport.fields.issueDate,
      type: IFieldType.datePicker,
      validation: {
        required: errors.required,
        validate: () => isIssueBeforeExpiry || userPassport.messages.issueBeforeExpiry,
      },
      onChange: (value: string) => handleIssueDateChange({ date: value }),
    },
    {
      name: "expiryDate",
      label: userPassport.fields.expiryDate,
      type: IFieldType.datePicker,
      validation: {
        required: errors.required,
        validate: () => isExpiryInFuture || userPassport.messages.expiryInFuture,
      },
      onChange: (value: string) => handleExpiryDateChange({ date: value }),
    },
    {
      name: "files",
      label: userPassport.fields.file,
      type: IFieldType.files,
      validation: {
        required: errors.required,
      },
      style: {
        gridColumn: "span 2",
      },
    },
    {
      name: "info",
      label: userPassport.fields.info,
      type: IFieldType.rte,
      style: {
        gridColumn: "span 2",
      },
    },
  ];
};
